<template>
	<div class="confirm-box" v-if="active">
		<div class="confirm-box-message">
			<div class="confirm-message">
				<span class="confirm-text-message">{{title}}</span>
			</div>
			<div class="confirm-bottom">
				<div class="create__btn" style="cursor: pointer;padding: 0 10px">
					<a class="cmn--btn" @click="onCanel()" style="background-color: red;"><span>{{$store.state.lang.text.cancel[$store.state.lang.language]}}</span></a>
				</div>
				<div class="create__btn" style="cursor: pointer;padding: 0 10px">
					<a class="cmn--btn" @click="onConfirm()"><span>{{$store.state.lang.text.confirm[$store.state.lang.language]}}</span></a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {'title':{ type: String }, 'active': { type: Boolean }},
	data () {
		return {
		}
	},
	methods: {
		onCanel () {
			this.$emit('onCancel');
			// this.active = false;
		},
		onConfirm () {
			this.$emit('onConfirm');
			// this.active = false;
		}
	}
}

</script>
<style>
	.box {
		z-index: 999999;
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		padding: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		background-color: rgba(0,0,0,0.7);
	}
	.message {
		width: 100%;
		text-align: center;
		padding: 18px 0;
	}
	.bottom {
		display: flex;
		justify-content: center;
	}
	.box-message {
		background-color: #FFF;
		border-radius: 15px;
		width: 100%;
		padding: 0px 20px;
		max-width: 360px;
	}
	.text-message {
		text-align: center;
		color: #333;
	}

</style>



// WEBPACK FOOTER //
// src/components/Confirm.vue